import { makeStyles } from "@fluentui/react-components";
import { projectIqTokens } from "apps/project-iq/theme/projectIqTokens";
import { designTokens } from "theme/customTheme";

const DIALOG_MAX_WIDTH = "1180px";
const DIALOG_MAX_HEIGHT = "88vh";
const DIALOG_HEIGHT = "780px";

export const useVaultMeetingsDialogStyles = makeStyles({
  surface: {
    width: "100%",
    maxWidth: DIALOG_MAX_WIDTH,
    height: `min(${DIALOG_HEIGHT}, ${DIALOG_MAX_HEIGHT})`,
    maxHeight: DIALOG_MAX_HEIGHT,
    boxSizing: "border-box",
    padding: 0,
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    backgroundColor: projectIqTokens.card,
    borderRadius: designTokens.borderRadius.lg,
    boxShadow: projectIqTokens.shadow,
    fontFamily: projectIqTokens.fontFamily,
  },
  body: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    minHeight: 0,
    gap: 0,
    overflow: "hidden",
  },
  titleBar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexShrink: 0,
    padding: `${designTokens.spacing[3]} ${designTokens.spacing[2]} ${designTokens.spacing[3]} ${designTokens.spacing[5]}`,
    borderBottom: `1px solid ${projectIqTokens.line2}`,
  },
  title: {
    margin: 0,
    fontSize: designTokens.fontSize.base,
    fontWeight: designTokens.fontWeight.bold,
    color: projectIqTokens.ink,
  },
  closeButton: {
    color: projectIqTokens.muted,
    flexShrink: 0,
  },
  content: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    minHeight: 0,
    gap: designTokens.spacing[3],
    padding: designTokens.spacing[4],
    overflowY: "auto",
    backgroundColor: projectIqTokens.bg,
  },
});
